import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Equipo } from 'src/app/shared/models/equipo';
import { ManoDeObra } from 'src/app/shared/models/mano-de-obra';
import { DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { Constanst } from 'src/app/core/constants/constans.component';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { BudgetItem } from 'src/app/shared/models/partida-presupuesto';
import { Select } from 'src/app/shared/models/select';
import { CachePartidasService } from 'src/app/core/services/cache-partidas-service';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { BudgetDetails } from 'src/app/shared/models/detalle-presupuesto';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { MaterialPriceReplace } from 'src/app/shared/models/material-precio-reemplazar';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-ver-apu-presupuesto',
  templateUrl: './ver-apu-presupuesto.component.html',
  styleUrls: ['./ver-apu-presupuesto.component.css'],
  providers: [DatePipe, DecimalPipe]
})
export class VerApuPresupuestoComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  displayedColumnsMaterial: string[] = ['position', 'reference', 'descripcion', 'unidad', 'cantidad', 'desperdicio', 'precio', 'total', 'fecha'];
  dataSourceMaterial = new MatTableDataSource<any>;
  displayedColumnsEquipos: string[] = ['position', 'reference', 'descripcion', 'cantidad', 'desperdicio', 'precio', 'total', 'fecha'];
  dataSourceEquipo = new MatTableDataSource<Equipo>;
  displayedColumnsManoObras: string[] = ['position', 'reference', 'descripcion', 'cantidad', 'jornal', 'bono', 'totaljornal', 'totalbono', 'fecha'];
  dataSourceManosObra = new MatTableDataSource<ManoDeObra>;
  displayedColumnsTotalPartida: string[] = ['descripcion', 'total'];
  reference: string = '';
  description: string = '';
  budgetDepartureDetailForm: FormGroup;
  oilCompany: boolean = false;
  factorAjuste: number;
  rendAjustado: number;
  materialDetailList: any[] = [];
  equipmentDetailList: any[] = [];
  laborDetailList: any[] = [];
  totalMateriales: number;
  porcIncidenciasMateriales: number;
  costoUnicoMateriales: number;
  totalEquipos: number;
  porcIncidenciasEquipos: number;
  costoUnicoEquipo: number;
  totalBonoManoDeObra: number;
  totalManoDeObra: number;
  porcPrestacionesManoDeObra: number;
  prestManoDeObra: number;
  totalGeneralManoDeObra: number | null;
  porcIncidenciasManoDeObra: number;
  costoUnicoManoDeObra: number;
  costoDirectoSubTotalA: number;
  porcGastosAdministrativos: number;
  gastosGeneralesAdmin: number;
  subTotalB: number;
  porcUtilidadesImprevisto: number;
  utilidadesImprevisto: number;
  subTotalC: number;
  workingHour: number = 8;
  porcFinanciamiento: number;
  financiamiento: number;
  workingHourDay: number;
  precioUnitarioSinImpuesto: number;
  horasRendimiento: number;
  porcImpuestoIva: number;
  montoImpuestoIva: number;
  precioUnitarioHorasRend: number;
  porcOtrosImpuestos: number;
  montoOtrosImpuestos: number;
  precioUnitario: number;
  apuConditionId: number = 0;
  rendimiento: number;

  totalGeneralManoDeObraTrans: string | undefined;
  costoUnicoManoDeObraRounded: string | undefined;
  costoUnicoEquipoRounded: string | undefined;
  costoDirectoSubTotalARounded: string | undefined;
  costoUnicoMaterialesRounded: string | undefined;
  subTotalBRounded: string | undefined;
  precioUnitarioRounded: string | undefined;
  horasRendimientoRounded: string | undefined;
  totalTrabajadores: any;

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  budgetItemUpdateDate: Date;
  infoPresupuesto: BudgetDetails;

  currentSlide = 0;
  listSelectLineItemsBudget: Select[] = [];
  listLineItemsBudget: BudgetItem[] = [];
  selectedLineItemBudget = new FormControl('0');
  activeLineItemsBudget: string;
  idCurrentSlide: number = 0;
  disablePrevious = false;
  disableNext = false;
  disableTodosPdf: boolean;
  procesTodosPdf: boolean;
  idBudgetLineItemCurrentSlide: number = 0;
  benefitCurrentSlide: number = 0;
  administrativeExpenseCurrentSlide: number = 0;
  unexpectedUtilityCurrentSlide: number = 0;
  financingCurrentSlide: number = 0;
  ivaCurrentSlide: number = 0;
  otherTaxCurrentSlide: number = 0;
  idCurrentSlideUser: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public pBudgetItem: BudgetItem,
    public dialogVerApuPresupuestoRef: MatDialogRef<VerApuPresupuestoComponent>,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private cachePartidasService: CachePartidasService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe
  ) { }

  ngOnInit() {
    registerLocaleData(es);
    this.infoPresupuesto = this.helperClassService.getData();
    this.listLineItemsBudget = [];
    this.budgetDepartureDetailForm = new FormGroup({
      description: new FormControl({ value: '', disabled: true }),
      shortDescription: new FormControl({ value: '', disabled: true }),
      reference: new FormControl({ value: '', disabled: true }),
      code: new FormControl({ value: '', disabled: true }),
      unity: new FormControl({ value: '', disabled: true }),
      yield: new FormControl({ value: '', disabled: true }),
      group: new FormControl({ value: '', disabled: true }),
      date: new FormControl({ value: '', disabled: true }),
      rating: new FormControl({ value: '', disabled: true }),
      commentary: new FormControl({ value: '', disabled: true }),
      conditions: new FormControl({ value: '', disabled: true }),
      clasification: new FormControl({ value: '', disabled: true }),
      quantity: new FormControl({ value: '', disabled: true }),
      dividirMaterial: new FormControl({ value: false, disabled: true }),
      lossPermission: new FormControl({ value: '', disabled: true }),
      difficulty: new FormControl({ value: '', disabled: true }),
      unplanned: new FormControl({ value: '', disabled: true }),
      mobilization: new FormControl({ value: '', disabled: true }),
      other: new FormControl({ value: '', disabled: true }),
      position: new FormControl({ value: '', disabled: true })
    });

    this.cachePartidasService.getAll().subscribe((data: BudgetItem[]) => {
      this.listLineItemsBudget = data;
    });
    this.consultLineItemDetails();
    this.loadListBudgetLineItems();

    this.cachePartidasService.getOnBudgetById('procesTodosPdf').subscribe((value: string) => {
      if (value == null || value.trim() == '') {
        this.cachePartidasService.saveOnBudget('procesTodosPdf', 'false');
        this.disableTodosPdf = false;
      } else {
        this.disableTodosPdf = (value == 'true' ? true : false);
      }
    });
  }

  onFirstClick() {
    this.currentSlide = 1;
    this.setIdCurrentSlide(this.currentSlide);
    this.consultLineItemDetails();
  }

  onPreviousClick() {
    this.currentSlide = this.currentSlide - 1;
    this.setIdCurrentSlide(this.currentSlide);
    this.consultLineItemDetails();
  }

  onNextClick() {
    this.currentSlide = this.currentSlide + 1;
    this.setIdCurrentSlide(this.currentSlide);
    this.consultLineItemDetails();
  }

  onLastClick() {
    this.currentSlide = this.listLineItemsBudget.length;
    this.setIdCurrentSlide(this.currentSlide);
    this.consultLineItemDetails();
  }

  onChangeSelect() {
    this.idCurrentSlide = Number(this.selectedLineItemBudget.value);
    this.setCurrentSlide(this.idCurrentSlide);
    this.consultLineItemDetails();
  }

  consultLineItemDetails() {
    this.route = ''; this.method = ''; let data = {};
    let valorLineItemUser = (this.idCurrentSlide == 0 ? this.pBudgetItem.idLineItemUser : this.idCurrentSlideUser);
    let valorLineItem = (this.idCurrentSlide == 0 ? this.pBudgetItem.idLineItem : this.idCurrentSlide);

    if (valorLineItemUser == 0) {
    //Partida no agregada al presupuesto, buscar resumen en tablas originales.
      this.route = '/getLineItem';
      this.method = 'POST';
      data = {
        idLineItem: valorLineItem
      }
    } else {
      //Partida agregada al presupuesto, buscar resumen en tablas de presupuesto.
      this.route = '/getLineItemUser';
      this.method = 'POST';
      data = {
        idLineItemUser: valorLineItemUser
      }
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(
        responseItem => {

          if (responseItem.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            //Opcion por defecto en el select de partidas del presupuesto
            this.activeLineItemsBudget = String(valorLineItem);
            this.setCurrentSlide(valorLineItem);

            this.budgetItemUpdateDate = responseItem.data.updateDate;

            this.budgetDepartureDetailForm = new FormGroup({
              description: new FormControl({ value: responseItem.data.description, disabled: true }),
              shortDescription: new FormControl({ value: responseItem.data.shortDescription, disabled: true }),
              reference: new FormControl({ value: responseItem.data.reference, disabled: true }),
              code: new FormControl({ value: responseItem.data.code, disabled: true }),
              unity: new FormControl({ value: responseItem.data.unit, disabled: true }),
              yield: new FormControl({ value: this.decimalPipe.transform(responseItem.data.normalPerformance, '1.6-6', 'es'), disabled: true }),
              group: new FormControl({ value: this.pBudgetItem.lineItemGrouping, disabled: true }),
              date: new FormControl({ value: this.datePipe.transform(this.budgetItemUpdateDate, 'dd/MM/yyyy'), disabled: true }),
              rating: new FormControl({ value: responseItem.data.rating, disabled: true }),
              commentary: new FormControl({ value: '', disabled: true }),
              conditions: new FormControl({ value: responseItem.data.apuCondition, disabled: true }),
              clasification: new FormControl({ value: responseItem.data.lineItemConditionDescription, disabled: true }),
              quantity: new FormControl({ value: this.decimalPipe.transform(this.pBudgetItem.quantity, '1.2-2', 'es'), disabled: true }),
              dividirMaterial: new FormControl({ value: responseItem.data.mrOption, disabled: true }),
              lossPermission: new FormControl({ value: this.decimalPipe.transform(responseItem.data.lossPermission, '1.6', 'es'), disabled: true }),
              difficulty: new FormControl({ value: this.decimalPipe.transform(responseItem.data.difficulty, '1.6', 'es'), disabled: true }),
              unplanned: new FormControl({ value: this.decimalPipe.transform(responseItem.data.unplanned, '1.6', 'es'), disabled: true }),
              mobilization: new FormControl({ value: this.decimalPipe.transform(responseItem.data.mobilization, '1.6', 'es'), disabled: true }),
              other: new FormControl({ value: this.decimalPipe.transform(responseItem.data.other, '1.6', 'es'), disabled: true }),
              position: new FormControl({ value: this.currentSlide, disabled: true })
            });

            //Activar o desactivar boton next paginacion
            if (this.currentSlide == this.listLineItemsBudget.length) {
              this.disableNext = true;
            } else {
              this.disableNext = false;
            }
            //Activar o desactivar boton previous paginacion
            if (this.currentSlide == 1) {
              this.disablePrevious = true;
            } else {
              this.disablePrevious = false;
            }

            this.description = responseItem.data.description;
            this.reference = responseItem.data.reference;

            let materialDetailList: any[] = responseItem.data.materialDetailList;
            if (valorLineItemUser == 0) {
            //Se debe validar y reemplazar precios de materiales.
              if (materialDetailList.length > 0) {
                let materialPriceReplaceList: any[] = [];
                this.cachePartidasService.getOnBudgetById(Constanst.CACHE_MATERIAL_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
                  materialPriceReplaceList = priceReplaceList;
                });
                if (materialPriceReplaceList !== undefined && materialPriceReplaceList.length > 0) {
                  for (let i = 0; i < materialDetailList.length; i++) {
                    for (let j = 0; j < materialPriceReplaceList.length; j++) {
                      if (materialDetailList[i].referenceMaterial.trim() == materialPriceReplaceList[j].materialReference.trim()) {
                        materialDetailList[i].priceMaterial = materialPriceReplaceList[j].price;
                        //materialDetailList[i].materialQuantity = materialPriceReplaceList[j].materialQuantity;
                        materialDetailList[i].wasteMaterial = materialPriceReplaceList[j].materialDepreciation;
                        let calculo = Number(this.decimalPipe.transform(materialDetailList[i].priceMaterial * materialDetailList[i].materialQuantity, '1.4-4')?.replace(',', '')) * (1 + (materialDetailList[i].wasteMaterial / 100));
                        materialDetailList[i].materialTotalPrice = Number(this.decimalPipe.transform(calculo, '1.2-2')?.replace(',', ''));
                      }
                    }
                  }
                }
              }
            }

            let equipmentDetailList: any[] = responseItem.data.equipmentDetailList;
            if (valorLineItemUser == 0) {
            //Se debe validar y reemplazar precios de equipos.
              if (equipmentDetailList.length > 0) {
                let equipmentPriceReplaceList: any[] = [];
                this.cachePartidasService.getOnBudgetById(Constanst.CACHE_EQUIPMENT_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
                  equipmentPriceReplaceList = priceReplaceList;
                });
                if (equipmentPriceReplaceList !== undefined && equipmentPriceReplaceList.length > 0) {
                  for (let i = 0; i < equipmentDetailList.length; i++) {
                    for (let j = 0; j < equipmentPriceReplaceList.length; j++) {
                      if (equipmentDetailList[i].equipmentReference.trim() == equipmentPriceReplaceList[j].equipmentReference.trim()) {
                        equipmentDetailList[i].priceEquipment = equipmentPriceReplaceList[j].equipmentPriceChanged;
                        //equipmentDetailList[i].quantityEquipment = equipmentPriceReplaceList[j].equipmentQuantity;
                        equipmentDetailList[i].depreciationEquipment = equipmentPriceReplaceList[j].equipmentDepreciation;
                        equipmentDetailList[i].equipmentTotalPrice = Number(this.decimalPipe.transform(equipmentDetailList[i].priceEquipment * equipmentDetailList[i].depreciationEquipment, '1.6-6')?.replace(',', '')) * (Number(this.decimalPipe.transform(equipmentDetailList[i].quantityEquipment, '1.2-2')?.replace(',', '')));
                      }
                    }
                  }
                }
              }
            }

            let laborDetailList: any[] = responseItem.data.laborDetailList;
            if (valorLineItemUser == 0) {
            //Se debe validar y reemplazar precios de mano de obra.
              if (laborDetailList.length > 0) {
                let laborPriceReplaceList: any[] = [];
                this.cachePartidasService.getOnBudgetById(Constanst.CACHE_LABOR_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
                  laborPriceReplaceList = priceReplaceList;
                });
                if (laborPriceReplaceList !== undefined && laborPriceReplaceList.length > 0) {
                  for (let i = 0; i < laborDetailList.length; i++) {
                    for (let j = 0; j < laborPriceReplaceList.length; j++) {
                      if (laborDetailList[i].laborReference.trim() == laborPriceReplaceList[j].laborReference.trim()) {
                        laborDetailList[i].priceLabor = laborPriceReplaceList[j].laborPriceChange;
                        //laborDetailList[i].quantityLabor = laborPriceReplaceList[j].quantityLabor;
                        laborDetailList[i].jornalLabor = laborPriceReplaceList[j].jornalLabor;
                        laborDetailList[i].laborTotalBonus = Number(this.decimalPipe.transform(laborDetailList[i].quantityLabor * laborDetailList[i].priceLabor, '1.2-2')?.replace(',', ''));
                      }
                    }
                  }
                }
              }
            }

            //Listas para mostrar en pagina detalle
            this.dataSourceEquipo.data = equipmentDetailList;
            this.dataSourceManosObra.data = laborDetailList;
            this.dataSourceMaterial.data = materialDetailList;

            //Listas para mostrar en PDF
            this.equipmentDetailList = equipmentDetailList;
            this.materialDetailList = materialDetailList;
            this.laborDetailList = laborDetailList;

            this.oilCompany = responseItem.data.oilCompany;

            this.factorAjuste = responseItem.data.lossPermission * responseItem.data.difficulty * responseItem.data.unplanned *
              responseItem.data.mobilization * responseItem.data.other;

            this.rendAjustado = this.factorAjuste * responseItem.data.normalPerformance;

            //Calculo de Totales
            this.totalMateriales = materialDetailList.map((t: { materialTotalPrice: any; }) => t.materialTotalPrice).reduce((acc: number, value: number) => acc + value, 0);
            this.totalEquipos = equipmentDetailList.map((t: { equipmentTotalPrice: any; }) => t.equipmentTotalPrice).reduce((acc: number, value: number) => acc + value, 0);
            this.totalManoDeObra = laborDetailList.map((t: { laborTotalJornal: any; }) => t.laborTotalJornal).reduce((acc: number, value: number) => acc + value, 0);
            this.totalBonoManoDeObra = laborDetailList.map((t: { laborTotalBonus: any; }) => t.laborTotalBonus).reduce((acc: number, value: number) => acc + value, 0);
            this.apuConditionId = responseItem.data.idApuCondition;

            //Consulta de las condiciones de la APU
            this.rendimiento = responseItem.data.normalPerformance;
            //Seteando Porcentajes
            this.porcFinanciamiento = (this.idCurrentSlide == 0 ? this.pBudgetItem.financing : this.financingCurrentSlide);
            this.porcGastosAdministrativos = (this.idCurrentSlide == 0 ? this.pBudgetItem.administrativeExpense : this.administrativeExpenseCurrentSlide);
            this.porcImpuestoIva = (this.idCurrentSlide == 0 ? this.pBudgetItem.iva : this.ivaCurrentSlide);
            this.porcOtrosImpuestos = (this.idCurrentSlide == 0 ? this.pBudgetItem.otherTax : this.otherTaxCurrentSlide);
            this.porcUtilidadesImprevisto = (this.idCurrentSlide == 0 ? this.pBudgetItem.unexpectedUtility : this.unexpectedUtilityCurrentSlide);
            this.porcPrestacionesManoDeObra = (this.idCurrentSlide == 0 ? this.pBudgetItem.benefit : this.benefitCurrentSlide);

            //Calculo Materiales
            this.costoUnicoMateriales = this.totalMateriales;

            //Calculo Costo Unico Equipos
            this.costoUnicoEquipo = this.totalEquipos / this.rendimiento;

            //Calculos Mano de Obra
            this.prestManoDeObra = (this.porcPrestacionesManoDeObra / 100) * Number(this.decimalPipe.transform(this.totalManoDeObra, '1.2')?.replace(',', ''));
            this.totalGeneralManoDeObra = this.totalManoDeObra + this.totalBonoManoDeObra + this.prestManoDeObra;

            this.totalGeneralManoDeObraTrans = (this.decimalPipe.transform(this.totalGeneralManoDeObra, '1.2-2'))?.replace(',', '');
            this.costoUnicoManoDeObra = Number(this.totalGeneralManoDeObraTrans) / this.rendimiento;

            this.costoUnicoManoDeObraRounded = (this.decimalPipe.transform(this.costoUnicoManoDeObra, '1.2-2'))?.replace(',', '');
            this.costoUnicoEquipoRounded = (this.decimalPipe.transform(this.costoUnicoEquipo, '1.2-2'))?.replace(',', '');
            this.costoUnicoMaterialesRounded = (this.decimalPipe.transform(this.costoUnicoMateriales, '1.2-2'))?.replace(',', '');

            //Calculos Partida
            this.costoDirectoSubTotalA = (Number(this.costoUnicoMaterialesRounded) + Number(this.costoUnicoEquipoRounded) + Number(this.costoUnicoManoDeObraRounded));
            this.costoDirectoSubTotalARounded = (this.decimalPipe.transform(this.costoDirectoSubTotalA, '1.2-2'))?.replace(',', '');

            this.gastosGeneralesAdmin = Number(this.costoDirectoSubTotalARounded) * (this.porcGastosAdministrativos / 100);
            let gastosGeneralesAdminRounded = (this.decimalPipe.transform(this.gastosGeneralesAdmin, '1.2-2'))?.replace(',', '');

            this.subTotalB = (Number(this.costoDirectoSubTotalARounded)) + (Number(gastosGeneralesAdminRounded));
            this.subTotalBRounded = (this.decimalPipe.transform(this.subTotalB, '1.2-2'))?.replace(',', '');

            this.utilidadesImprevisto = (Number(this.subTotalBRounded) * this.porcUtilidadesImprevisto) / 100;

            this.subTotalC = (Number(this.subTotalBRounded)) + this.utilidadesImprevisto;

            this.financiamiento = (this.subTotalC * this.porcFinanciamiento) / 100;

            this.precioUnitarioSinImpuesto = this.subTotalC + this.financiamiento;
            this.montoImpuestoIva = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_APU ? this.precioUnitarioSinImpuesto * (this.porcImpuestoIva / 100) : 0);
            this.montoOtrosImpuestos = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_APU ? this.precioUnitarioSinImpuesto * (this.porcOtrosImpuestos / 100) : 0);

            this.precioUnitario = this.precioUnitarioSinImpuesto + this.montoImpuestoIva + this.montoOtrosImpuestos;
            this.precioUnitarioRounded = (this.decimalPipe.transform(this.precioUnitario, '1.2-2'))?.replace(',', '');

            //Calculo % de incidencias
            this.porcIncidenciasMateriales = ((Number(this.costoUnicoMaterialesRounded)) / (Number(this.costoDirectoSubTotalARounded))) * 100;
            this.porcIncidenciasManoDeObra = ((Number(this.costoUnicoManoDeObraRounded)) / (Number(this.costoDirectoSubTotalARounded))) * 100;
            this.porcIncidenciasEquipos = ((Number(this.costoUnicoEquipoRounded)) / (Number(this.costoDirectoSubTotalARounded))) * 100;

            this.totalTrabajadores = laborDetailList.map((t: { quantityLabor: any; }) => t.quantityLabor).reduce((acc: number, value: number) => acc + value, 0);
            this.workingHourDay = this.totalTrabajadores * this.workingHour;
            this.horasRendimiento = this.workingHourDay / this.rendimiento;
            this.horasRendimientoRounded = (this.decimalPipe.transform(this.horasRendimiento, '1.3-3'))?.replace(',', '');
            this.precioUnitarioHorasRend = (Number(this.precioUnitarioRounded)) / (Number(this.horasRendimientoRounded));

            this.apiCallService.hideSpinner();
          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
        }
      );
  }

  loadListBudgetLineItems() {
    let lista = this.listLineItemsBudget;
    for (let i = 0; i < lista.length; i++) {
      let budget: Select = { id: '', value: '' };
      budget.id = String(lista[i].idLineItem);
      budget.value = ('Partida Nro ' + (i + 1));
      this.listSelectLineItemsBudget.push(budget);

      if (lista[i].idLineItem == Number(this.selectedLineItemBudget)) {
        this.currentSlide = (i + 1);
      }
    }
  }

  private setIdCurrentSlide(index: number) {
    this.idCurrentSlide = this.listLineItemsBudget[(index - 1)].idLineItem;
    this.idBudgetLineItemCurrentSlide = this.listLineItemsBudget[(index - 1)].idBudgetLineItem;
    this.benefitCurrentSlide = this.listLineItemsBudget[(index - 1)].benefit;
    this.administrativeExpenseCurrentSlide = this.listLineItemsBudget[(index - 1)].administrativeExpense;
    this.unexpectedUtilityCurrentSlide = this.listLineItemsBudget[(index - 1)].unexpectedUtility;
    this.financingCurrentSlide = this.listLineItemsBudget[(index - 1)].financing;
    this.ivaCurrentSlide = this.listLineItemsBudget[(index - 1)].iva;
    this.otherTaxCurrentSlide = this.listLineItemsBudget[(index - 1)].otherTax;
    this.idCurrentSlideUser = this.listLineItemsBudget[(index - 1)].idLineItemUser!;
  }

  private setCurrentSlide(id: number) {
    for (let i = 0; i < this.listLineItemsBudget.length; i++) {
      if (this.listLineItemsBudget[i].idLineItem == id) {
        this.currentSlide = i + 1;
        break;
      }
    }
  }

  async verDetallePDF(accion: string) {
    let reportpDFName = Constanst.PDF_REPORT_NAME.concat(this.pBudgetItem.reference);
    let reportpDFWatermark = String(await this.helperClassService.toBase64Image(Constanst.PDF_REPORT_WATERMARK));

    var rowsMaterial = [];
    rowsMaterial.push([{ text: 'N°', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Und.', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Desp.', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Precio', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Material', style: 'subheader', bold: true, alignment: 'center' }]);
    for (let [i, material] of this.materialDetailList.entries()) {
      rowsMaterial.push([{ text: material.materialPosition, style: 'subheader', alignment: 'center' }, { text: material.materialDescription, style: 'subheader', alignment: 'left' }, { text: material.materialUnit, style: 'subheader', alignment: 'center' }, { text: this.decimalPipe.transform(material.materialQuantity, '1.4-4', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(material.wasteMaterial, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(material.priceMaterial, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(material.materialTotalPrice, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }]);
    }
    rowsMaterial.push([{ text: 'Total Materiales', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, true, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalMateriales, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsMaterial.push([{ text: 'Costo Unitario Materiales', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalMateriales, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);

    var rowsEquipment = [];
    rowsEquipment.push([{ text: 'N°', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', style: 'subheader', bold: true, alignment: 'center' }, { text: 'COP/Dep/Alq', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Precio', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Equipo', style: 'subheader', bold: true, alignment: 'center' }]);
    for (let [i, equipment] of this.equipmentDetailList.entries()) {
      rowsEquipment.push([{ text: equipment.equipmentPosition, style: 'subheader', alignment: 'center' }, { text: equipment.equipmentDescription, style: 'subheader', alignment: 'left' }, { text: this.decimalPipe.transform(equipment.quantityEquipment, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(equipment.depreciationEquipment, '1.6-6', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(equipment.priceEquipment, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(equipment.equipmentTotalPrice, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }]);
    }
    rowsEquipment.push([{ text: 'Total Equipos', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, true, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalEquipos, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsEquipment.push([{ text: 'Costo Unitario Equipos', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.costoUnicoEquipo, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);

    var rowsLabor = [];
    rowsLabor.push([{ text: 'N°', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', bold: true, style: 'subheader', alignment: 'center' }, { text: 'Jornal', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Bono', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Bono', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Jornal', style: 'subheader', bold: true, alignment: 'center' }]);
    for (let [i, labor] of this.laborDetailList.entries()) {
      rowsLabor.push([{ text: labor.laborPosition, style: 'subheader', alignment: 'center' }, { text: labor.laborDescription, style: 'subheader', alignment: 'left' }, { text: this.decimalPipe.transform(labor.quantityLabor, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.jornalLabor, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.laborTotalBonus, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.laborTotalBonus, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.laborTotalJornal, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }]);
    }
    rowsLabor.push([{ text: 'Subtotal Mano de Obra', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, true, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalBonoManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }, { text: this.decimalPipe.transform(this.totalManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsLabor.push([{ text: this.porcPrestacionesManoDeObra + '% Prestaciones Sociales', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, { text: '0.00', alignment: 'right', style: 'subheader' }, { text: this.decimalPipe.transform(this.prestManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsLabor.push([{ text: 'SubTotal + Prestaciones', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalBonoManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }, { text: this.decimalPipe.transform((this.prestManoDeObra + this.totalManoDeObra), '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsLabor.push([{ text: 'Total General Mano de Obra', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.totalGeneralManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
    rowsLabor.push([{ text: 'Costo Unico Mano de Obra', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(this.costoUnicoManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);

    let companyBudget = this.infoPresupuesto.companyBudget;
    let docDefinition = {
      pageMargin: [5, 50, 10, 20],
      pageSizes: Constanst.PDF_REPORT_PAGE_SIZE,
      background: {
        image: reportpDFWatermark,
        width: 600,
        absolutePosition: {
          x: 0, //Centra horizontalmente
          y: 100 //Centra verticalmente
        }
      },
      header: function (currentPage: any, pageCount: any) {
        return {
        margin: 8,
        table: {
          widths: ['*', '*'],
          body: [
            [{ text: companyBudget, fontSize: 12, bold: true, alignment: 'left', border: [false, false, false, false] },
              { text: Constanst.PDF_REPORT_HADER_TEXT.concat('\n').concat(Constanst.PDF_REPORT_FOOTER_ONE + currentPage.toString() + Constanst.PDF_REPORT_FOOTER_TWO + pageCount), style: 'small', border: [false, false, false, false], alignment: 'right' }]
          ]
        }
        };
      },
      info: {
        title: reportpDFName,
        author: Constanst.PDF_REPORT_INFO_AUTHOR,
        subject: Constanst.PDF_REPORT_INFO_SUBJECT,
        keywords: Constanst.PDF_REPORT_INFO_KEYWORDS,
        creator: Constanst.PDF_REPORT_INFO_CREATOR,
        producer: Constanst.PDF_REPORT_INFO_PRODUCER
      },
      content: [
        {
          table: {
            widths: ['*'],
            body: [
              [{ text: 'ANALISIS DE PRECIO UNITARIO', fontSize: 12, bold: true, alignment: 'center', border: [false, false, false, false] }]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*'],
            body: [
              [{ text: 'Descripción: '.concat(this.pBudgetItem.description), fontSize: 9, bold: true, alignment: 'left', border: [false, false, false, false] }]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            widths: [44, '*', 30, '*', 30, '*', 52, '*', 30, '*'],
            body: [
              [{ text: 'Referencia: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: this.pBudgetItem.reference, style: 'subheader', border: [false, false, false, false] }, { text: 'Código: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: this.pBudgetItem.code, style: 'subheader', border: [false, false, false, false] }, { text: 'Unidad: ', bold: true, style: 'subheader', border: [false, false, false, false] }, { text: this.pBudgetItem.unit, style: 'subheader', border: [false, false, false, false] }, { text: 'Rendimiento: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.pBudgetItem.performance, '1.6-6', 'es'), style: 'subheader', border: [false, false, false, false] }, { text: 'Fecha: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: this.datePipe.transform(this.budgetItemUpdateDate, 'dd/MM/yyyy'), style: 'subheader', border: [false, false, false, false] }],
            ]
          }
        },
        {
          text: '1. MATERIALES',
          style: 'header',
        },
        {
          style: 'tableExample',
          table: {
            widths: [10, 215, 30, 37, 35, 55, 60],
            body: rowsMaterial
          }
        },
        {
          text: '2. EQUIPOS',
          style: 'header',
        },
        {
          style: 'tableExample',
          table: {
            widths: [10, 215, 40, 65, 63, 60],
            body: rowsEquipment
          }
        },
        {
          text: '3. MANO DE OBRA',
          style: 'header',
        },
        {
          style: 'tableExample',
          table: {
            widths: [10, 215, 37, 37, 37, 50, 60],
            body: rowsLabor
          }
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*', 108],
            body: [
              [{ text: 'Costo Directo SubTotal A', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.costoDirectoSubTotalA, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: this.porcGastosAdministrativos + '% Administración y Gastos Generales', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.gastosGeneralesAdmin, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: 'SubTotal B', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.subTotalB, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: this.porcUtilidadesImprevisto + '% Utilidad e Imprevistos', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.utilidadesImprevisto, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: 'SubTotal C', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.subTotalC, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: this.porcFinanciamiento + '% Financiamientos', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.financiamiento, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: 'Precio Unitario sin Impuestos', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.precioUnitarioSinImpuesto, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: this.porcImpuestoIva + '% Impuestos (I.V.A)', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.montoImpuestoIva, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
              [{ text: this.porcOtrosImpuestos + '% Otros Impuestos (I.V.A)', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.montoOtrosImpuestos, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]
            ]
          }
        },
        {
          style: 'tableExample',
          table: {
            widths: ['*', 108],
            body: [
              [{ text: 'PRECIO UNITARIO', style: 'header', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(this.precioUnitario, '1.2-2', 'es'), style: 'header', alignment: 'right' }]
            ]
          }
        }
      ],
      styles: {
        header: {
          fontSize: 9,
          bold: true,
        },
        subheader: {
          fontSize: 8,
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 8
        },
        tableExample: {
          margin: 3,
          fontSize: 9,
        }
      }
    };

    if (accion == 'open') {
      pdfMake.createPdf(docDefinition).open();
    } else {
      pdfMake.createPdf(docDefinition).download(reportpDFName);
    }
  }

  async generarTodosApuPDF(accion: string) {
    let reportpDFName = Constanst.PDF_REPORT_NAME_ALL;
    let reportpDFWatermark = String(await this.helperClassService.toBase64Image(Constanst.PDF_REPORT_WATERMARK));
    let materialDetailList: any[] = [];
    let equipmentDetailList: any[] = [];
    let laborDetailList: any[] = [];
    let oilCompany: boolean = false;
    let factorAjuste: number;
    let rendAjustado: number;
    let totalMateriales: number;
    let totalEquipos: number;
    let totalManoDeObra: number;
    let totalBonoManoDeObra: number;
    let rendimiento: number;
    let porcFinanciamiento: number;
    let porcGastosAdministrativos: number;
    let porcImpuestoIva: number;
    let porcOtrosImpuestos: number;
    let porcUtilidadesImprevisto: number;
    let porcPrestacionesManoDeObra: number;
    let costoUnicoMateriales: number;
    let costoUnicoEquipo: number;
    let prestManoDeObra: number;
    let totalGeneralManoDeObra: number | null;
    let totalGeneralManoDeObraTrans: string | undefined;
    let costoUnicoManoDeObra: number;
    let costoUnicoManoDeObraRounded: string | undefined;
    let costoUnicoEquipoRounded: string | undefined;
    let costoUnicoMaterialesRounded: string | undefined;
    let costoDirectoSubTotalA: number;
    let costoDirectoSubTotalARounded: string | undefined;
    let gastosGeneralesAdmin: number;
    let gastosGeneralesAdminRounded: string | undefined;
    let subTotalB: number;
    let subTotalBRounded: string | undefined;
    let utilidadesImprevisto: number;
    let subTotalC: number;
    let financiamiento: number;
    let precioUnitarioSinImpuesto: number;
    let montoImpuestoIva: number;
    let montoOtrosImpuestos: number;
    let precioUnitario: number;
    let precioUnitarioRounded: string | undefined;
    let porcIncidenciasMateriales: number;
    let porcIncidenciasManoDeObra: number;
    let porcIncidenciasEquipos: number;
    let totalTrabajadores: any;
    let workingHourDay: number;
    let workingHour: number = 8;
    let horasRendimiento: number;
    let horasRendimientoRounded: string | undefined;
    let precioUnitarioHorasRend: number;
    let dataDescription = '', dataReference = '', dataCode = '', dataUnit = '';
    let dataPerformance = 0;
    let dataUpdateDate: Date;
    let loadedAllPdf: boolean = true;

    let companyBudget = this.infoPresupuesto.companyBudget;
    let docDefinition = {
      pageSizes: Constanst.PDF_REPORT_PAGE_SIZE,
      pageMargin: [5, 50, 10, 20],
      background: {
        image: reportpDFWatermark,
        width: 600,
        absolutePosition: {
          x: 0, //Centra horizontalmente
          y: 100 //Centra verticalmente
        }
      },
      header: function (currentPage: any, pageCount: any) {
        return {
        margin: 8,
        table: {
          widths: ['*', '*'],
          body: [
            [{ text: companyBudget, fontSize: 12, bold: true, alignment: 'left', border: [false, false, false, false] },
              { text: Constanst.PDF_REPORT_HADER_TEXT.concat('\n').concat(Constanst.PDF_REPORT_FOOTER_ONE + currentPage.toString() + Constanst.PDF_REPORT_FOOTER_TWO + pageCount), style: 'small', border: [false, false, false, false], alignment: 'right' }]
          ]
        }
        };
      },
      info: {
        title: reportpDFName,
        author: Constanst.PDF_REPORT_INFO_AUTHOR,
        subject: Constanst.PDF_REPORT_INFO_SUBJECT,
        keywords: Constanst.PDF_REPORT_INFO_KEYWORDS,
        creator: Constanst.PDF_REPORT_INFO_CREATOR,
        producer: Constanst.PDF_REPORT_INFO_PRODUCER
      },
      content: new Array(),
      styles: {
        header: {
          fontSize: 9,
          bold: true,
        },
        subheader: {
          fontSize: 8,
        },
        quote: {
          italics: true
        },
        small: {
          fontSize: 8
        },
        tableExample: {
          margin: 3,
          fontSize: 9,
        }
      }
    };

    this.cachePartidasService.modifyOnBudget('procesTodosPdf', 'true');
    this.disableTodosPdf = true;
    for await (let [index, lineItem] of this.listLineItemsBudget.entries()) {
      let data1 = {};

      if (lineItem.idLineItemUser == 0) {
        this.route = '/getLineItem';
        this.method = 'POST';
        data1 = {
          idLineItem: lineItem.idLineItem
        }
      } else {
        this.route = '/getLineItemUser';
        this.method = 'POST';
        data1 = {
          idLineItemUser: lineItem.idLineItemUser
        }
      }

      const roleTypes$ = this.apiCallService.call$(data1, this.route, this.method, true, '', true);
      const responseItem = await lastValueFrom(roleTypes$);

      if (responseItem.status === Constanst.RESPONSE_STATUS_SUCCESS) {
        dataDescription = responseItem.data.description;
        dataReference = responseItem.data.reference;
        dataCode = responseItem.data.code;
        dataUnit = responseItem.data.unit;
        dataPerformance = responseItem.data.lowPerformance;
        dataUpdateDate = responseItem.data.updateDate;

        equipmentDetailList = responseItem.data.equipmentDetailList;
        if (lineItem.idLineItemUser == 0) {
          if (equipmentDetailList.length > 0) {
            let equipmentPriceReplaceList: any[] = [];
            this.cachePartidasService.getOnBudgetById(Constanst.CACHE_EQUIPMENT_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
              equipmentPriceReplaceList = priceReplaceList;
            });

            if (equipmentPriceReplaceList !== undefined && equipmentPriceReplaceList.length > 0) {
              for (let i = 0; i < equipmentDetailList.length; i++) {
                for (let j = 0; j < equipmentPriceReplaceList.length; j++) {
                  if (equipmentDetailList[i].equipmentReference == equipmentPriceReplaceList[j].equipmentReference) {
                    equipmentDetailList[i].priceEquipment = equipmentPriceReplaceList[j].equipmentPriceChanged;
                    //equipmentDetailList[i].quantityEquipment = equipmentPriceReplaceList[j].equipmentQuantity;
                    equipmentDetailList[i].depreciationEquipment = equipmentPriceReplaceList[j].equipmentDepreciation;
                    equipmentDetailList[i].equipmentTotalPrice = Number(this.decimalPipe.transform(equipmentDetailList[i].priceEquipment * equipmentDetailList[i].depreciationEquipment, '1.6-6')?.replace(',', '')) * (Number(this.decimalPipe.transform(equipmentDetailList[i].quantityEquipment, '1.2-2')?.replace(',', '')));
                  }
                }
              }
            }
          }
        }

        materialDetailList = responseItem.data.materialDetailList;
        if (lineItem.idLineItemUser == 0) {
          if (materialDetailList.length > 0) {
            let materialPriceReplaceList: any[] = [];
            this.cachePartidasService.getOnBudgetById(Constanst.CACHE_MATERIAL_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
              materialPriceReplaceList = priceReplaceList;
            });

            if (materialPriceReplaceList !== undefined && materialPriceReplaceList.length > 0) {
              for (let i = 0; i < materialDetailList.length; i++) {
                for (let j = 0; j < materialPriceReplaceList.length; j++) {
                  if (materialDetailList[i].referenceMaterial == materialPriceReplaceList[j].materialReference) {
                    materialDetailList[i].priceMaterial = materialPriceReplaceList[j].price;
                    //materialDetailList[i].materialQuantity = materialPriceReplaceList[j].materialQuantity;
                    materialDetailList[i].wasteMaterial = materialPriceReplaceList[j].materialDepreciation;
                    let calculo = Number(this.decimalPipe.transform(materialDetailList[i].priceMaterial * materialDetailList[i].materialQuantity, '1.4-4')?.replace(',', '')) * (1 + (materialDetailList[i].wasteMaterial / 100));
                    materialDetailList[i].materialTotalPrice = Number(this.decimalPipe.transform(calculo, '1.2-2')?.replace(',', ''));
                  }
                }
              }
            }
          }
        }

        laborDetailList = responseItem.data.laborDetailList;
        if (lineItem.idLineItemUser == 0) {
          if (laborDetailList.length > 0) {
            let laborPriceReplaceList: any[] = [];
            this.cachePartidasService.getOnBudgetById(Constanst.CACHE_LABOR_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
              laborPriceReplaceList = priceReplaceList;
            });

            if (laborPriceReplaceList !== undefined && laborPriceReplaceList.length > 0) {
              for (let i = 0; i < laborDetailList.length; i++) {
                for (let j = 0; j < laborPriceReplaceList.length; j++) {
                  if (laborDetailList[i].laborReference == laborPriceReplaceList[j].laborReference) {
                    laborDetailList[i].priceLabor = laborPriceReplaceList[j].laborPriceChange;
                    //laborDetailList[i].quantityLabor = laborPriceReplaceList[j].quantityLabor;
                    laborDetailList[i].jornalLabor = laborPriceReplaceList[j].jornalLabor;
                    laborDetailList[i].laborTotalBonus = Number(this.decimalPipe.transform(laborDetailList[i].quantityLabor * laborDetailList[i].priceLabor, '1.2-2')?.replace(',', ''));
                  }
                }
              }
            }
          }
        }

        oilCompany = responseItem.data.oilCompany;
        factorAjuste = responseItem.data.lossPermission * responseItem.data.difficulty * responseItem.data.unplanned * responseItem.data.mobilization * responseItem.data.other;
        rendAjustado = factorAjuste * responseItem.data.normalPerformance;

        totalMateriales = materialDetailList.map((t: { materialTotalPrice: any; }) => t.materialTotalPrice).reduce((acc: number, value: number) => acc + value, 0);
        totalEquipos = equipmentDetailList.map((t: { equipmentTotalPrice: any; }) => t.equipmentTotalPrice).reduce((acc: number, value: number) => acc + value, 0);
        totalManoDeObra = laborDetailList.map((t: { laborTotalJornal: any; }) => t.laborTotalJornal).reduce((acc: number, value: number) => acc + value, 0);
        totalBonoManoDeObra = laborDetailList.map((t: { laborTotalBonus: any; }) => t.laborTotalBonus).reduce((acc: number, value: number) => acc + value, 0);
        rendimiento = responseItem.data.normalPerformance;

        porcFinanciamiento = lineItem.financing;
        porcGastosAdministrativos = lineItem.administrativeExpense;
        porcImpuestoIva = lineItem.iva;
        porcOtrosImpuestos = lineItem.otherTax;
        porcUtilidadesImprevisto = lineItem.unexpectedUtility;
        porcPrestacionesManoDeObra = lineItem.benefit;

        //Calculo Costo Unitario Materiales
        costoUnicoMateriales = totalMateriales;

        //Calculo Costo Unico Equipos
        costoUnicoEquipo = totalEquipos / rendimiento;
        //Calculo Costo Unico Mano de Obra
        prestManoDeObra = (porcPrestacionesManoDeObra / 100) * Number(this.decimalPipe.transform(totalManoDeObra, '1.2-2')?.replace(',', ''));
        totalGeneralManoDeObra = totalManoDeObra + totalBonoManoDeObra + prestManoDeObra;
        totalGeneralManoDeObraTrans = (this.decimalPipe.transform(totalGeneralManoDeObra, '1.2-2'))?.replace(',', '');
        costoUnicoManoDeObra = Number(totalGeneralManoDeObraTrans) / rendimiento;
        //Costos Unicos Redondeados
        costoUnicoManoDeObraRounded = (this.decimalPipe.transform(costoUnicoManoDeObra, '1.2-2'))?.replace(',', '');
        costoUnicoEquipoRounded = (this.decimalPipe.transform(costoUnicoEquipo, '1.2-2'))?.replace(',', '');
        costoUnicoMaterialesRounded = (this.decimalPipe.transform(costoUnicoMateriales, '1.2-2'))?.replace(',', '');

        //Calculos Partida
        costoDirectoSubTotalA = (Number(costoUnicoMaterialesRounded) + Number(costoUnicoEquipoRounded) + Number(costoUnicoManoDeObraRounded));
        costoDirectoSubTotalARounded = (this.decimalPipe.transform(costoDirectoSubTotalA, '1.2-2'))?.replace(',', '');
        gastosGeneralesAdmin = Number(costoDirectoSubTotalARounded) * (porcGastosAdministrativos / 100);
        gastosGeneralesAdminRounded = (this.decimalPipe.transform(gastosGeneralesAdmin, '1.2-2'))?.replace(',', '');
        subTotalB = (Number(costoDirectoSubTotalARounded)) + (Number(gastosGeneralesAdminRounded));
        subTotalBRounded = (this.decimalPipe.transform(subTotalB, '1.2-2'))?.replace(',', '');
        utilidadesImprevisto = (Number(subTotalBRounded) * porcUtilidadesImprevisto) / 100;
        subTotalC = (Number(subTotalBRounded)) + utilidadesImprevisto;
        financiamiento = (subTotalC * porcFinanciamiento) / 100;
        precioUnitarioSinImpuesto = subTotalC + financiamiento;
        montoImpuestoIva = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_APU ? precioUnitarioSinImpuesto * (porcImpuestoIva / 100) : 0);
        montoOtrosImpuestos = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_APU ? precioUnitarioSinImpuesto * (porcOtrosImpuestos / 100) : 0);
        precioUnitario = precioUnitarioSinImpuesto + montoImpuestoIva + montoOtrosImpuestos;
        precioUnitarioRounded = (this.decimalPipe.transform(precioUnitario, '1.2-2'))?.replace(',', '');

        //Calculo % de incidencias
        porcIncidenciasMateriales = ((Number(costoUnicoMaterialesRounded)) / (Number(costoDirectoSubTotalARounded))) * 100;
        porcIncidenciasManoDeObra = ((Number(costoUnicoManoDeObraRounded)) / (Number(costoDirectoSubTotalARounded))) * 100;
        porcIncidenciasEquipos = ((Number(costoUnicoEquipoRounded)) / (Number(costoDirectoSubTotalARounded))) * 100;

        totalTrabajadores = laborDetailList.map((t: { quantityLabor: any; }) => t.quantityLabor).reduce((acc: number, value: number) => acc + value, 0);
        workingHourDay = totalTrabajadores * workingHour;
        horasRendimiento = workingHourDay / rendimiento;
        horasRendimientoRounded = (this.decimalPipe.transform(horasRendimiento, '1.3-3'))?.replace(',', '');
        precioUnitarioHorasRend = (Number(precioUnitarioRounded)) / (Number(horasRendimientoRounded));

        let rowsMaterial = [];
        rowsMaterial.push([{ text: 'N°', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Und.', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Desp.', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Precio', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Material', style: 'subheader', bold: true, alignment: 'center' }]);
        for (let [i, material] of materialDetailList.entries()) {
          rowsMaterial.push([{ text: material.materialPosition, style: 'subheader', alignment: 'center' }, { text: material.materialDescription, style: 'subheader', alignment: 'left' }, { text: material.materialUnit, style: 'subheader', alignment: 'center' }, { text: this.decimalPipe.transform(material.materialQuantity, '1.4-4', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(material.wasteMaterial, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(material.priceMaterial, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(material.materialTotalPrice, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }]);
        }
        rowsMaterial.push([{ text: 'Total Materiales', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, true, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(totalMateriales, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
        rowsMaterial.push([{ text: 'Costo Unitario Materiales', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(costoUnicoMateriales, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);

        let rowsEquipment = [];
        rowsEquipment.push([{ text: 'N°', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', style: 'subheader', bold: true, alignment: 'center' }, { text: 'COP/Dep/Alq', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Precio', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Equipo', style: 'subheader', bold: true, alignment: 'center' }]);
        for (let [i, equipment] of equipmentDetailList.entries()) {
          rowsEquipment.push([{ text: equipment.equipmentPosition, style: 'subheader', alignment: 'center' }, { text: equipment.equipmentDescription, style: 'subheader', alignment: 'left' }, { text: this.decimalPipe.transform(equipment.quantityEquipment, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(equipment.depreciationEquipment, '1.6-6', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(equipment.priceEquipment, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(equipment.equipmentTotalPrice, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }]);
        }
        rowsEquipment.push([{ text: 'Total Equipos', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, true, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(totalEquipos, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
        rowsEquipment.push([{ text: 'Costo Unitario Equipos', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(costoUnicoEquipo, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);

        let rowsLabor = [];
        rowsLabor.push([{ text: 'N°', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', bold: true, style: 'subheader', alignment: 'center' }, { text: 'Jornal', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Bono', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Bono', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Jornal', style: 'subheader', bold: true, alignment: 'center' }]);
        for (let [i, labor] of laborDetailList.entries()) {
          rowsLabor.push([{ text: labor.laborPosition, style: 'subheader', alignment: 'center' }, { text: labor.laborDescription, style: 'subheader', alignment: 'left' }, { text: this.decimalPipe.transform(labor.quantityLabor, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.jornalLabor, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.laborTotalBonus, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.laborTotalBonus, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }, { text: this.decimalPipe.transform(labor.laborTotalJornal, '1.2-2', 'es'), style: 'subheader', alignment: 'right' }]);
        }
        rowsLabor.push([{ text: 'Subtotal Mano de Obra', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, true, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(totalBonoManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }, { text: this.decimalPipe.transform(totalManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
        rowsLabor.push([{ text: porcPrestacionesManoDeObra + '% Prestaciones Sociales', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, { text: '0.00', alignment: 'right', style: 'subheader' }, { text: this.decimalPipe.transform(prestManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
        rowsLabor.push([{ text: 'SubTotal + Prestaciones', style: 'subheader', bold: true, colSpan: 5, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, { text: this.decimalPipe.transform(totalBonoManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }, { text: this.decimalPipe.transform((prestManoDeObra + totalManoDeObra), '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
        rowsLabor.push([{ text: 'Total General Mano de Obra', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(totalGeneralManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);
        rowsLabor.push([{ text: 'Costo Unitario Mano de Obra', style: 'subheader', bold: true, colSpan: 6, alignment: 'right', border: [false, false, true, false] }, {}, {}, {}, {}, {}, { text: this.decimalPipe.transform(costoUnicoManoDeObra, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]);

        docDefinition.content.push(
          {
            table: {
              widths: ['*'],
              body: [
                [{ text: 'ANALISIS DE PRECIO UNITARIO', fontSize: 12, bold: true, alignment: 'center', border: [false, false, false, false] }]
              ]
            }
          },
          {
            style: 'tableExample',
            table: {
              widths: ['*'],
              body: [
                [{ text: 'Descripción: '.concat(dataDescription), fontSize: 9, bold: true, alignment: 'left', border: [false, false, false, false] }]
              ]
            }
          },
          {
            style: 'tableExample',
            table: {
              widths: [44, '*', 30, '*', 30, '*', 52, '*', 30, '*'],
              body: [
                [{ text: 'Referencia: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: dataReference, style: 'subheader', border: [false, false, false, false] }, { text: 'Código: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: dataCode, style: 'subheader', border: [false, false, false, false] }, { text: 'Unidad: ', bold: true, style: 'subheader', border: [false, false, false, false] }, { text: dataUnit, style: 'subheader', border: [false, false, false, false] }, { text: 'Rendimiento: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: this.decimalPipe.transform(dataPerformance, '1.6-6', 'es'), style: 'subheader', border: [false, false, false, false] }, { text: 'Fecha: ', style: 'subheader', bold: true, border: [false, false, false, false] }, { text: this.datePipe.transform(dataUpdateDate, 'dd/MM/yyyy'), style: 'subheader', border: [false, false, false, false] }],
              ]
            }
          },
          {
            text: '1. MATERIALES',
            style: 'header',
          },
          {
            style: 'tableExample',
            table: {
              widths: [10, 215, 30, 37, 35, 55, 60],
              body: rowsMaterial
            }
          },
          {
            text: '2. EQUIPOS',
            style: 'header',
          },
          {
            style: 'tableExample',
            table: {
              widths: [10, 215, 40, 65, 63, 60],
              body: rowsEquipment
            }
          },
          {
            text: '3. MANO DE OBRA',
            style: 'header',
          },
          {
            style: 'tableExample',
            table: {
              widths: [10, 215, 37, 37, 37, 50, 60],
              body: rowsLabor
            }
          },
          {
            style: 'tableExample',
            table: {
              widths: ['*', 108],
              body: [
                [{ text: 'Costo Directo SubTotal A', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(costoDirectoSubTotalA, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
                [{ text: porcGastosAdministrativos + '% Administración y Gastos Generales', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(gastosGeneralesAdmin, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
                [{ text: 'SubTotal B', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(subTotalB, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
                [{ text: porcUtilidadesImprevisto + '% Utilidad e Imprevistos', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(utilidadesImprevisto, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
                [{ text: 'SubTotal C', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(subTotalC, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
                [{ text: porcFinanciamiento + '% Financiamientos', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(financiamiento, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
                [{ text: 'Precio Unitario sin Impuestos', style: 'subheader', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(precioUnitarioSinImpuesto, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
                [{ text: porcImpuestoIva + '% Impuestos (I.V.A)', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(montoImpuestoIva, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }],
                [{ text: porcOtrosImpuestos + '% Otros Impuestos (I.V.A)', style: 'subheader', alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(montoOtrosImpuestos, '1.2-2', 'es'), alignment: 'right', style: 'subheader' }]
              ]
            }
          },
          {
            style: 'tableExample',
            table: {
              widths: ['*', 108],
              body: [
                [{ text: 'PRECIO UNITARIO', style: 'header', bold: true, alignment: 'right', border: [false, false, false, false] }, { text: this.decimalPipe.transform(precioUnitario, '1.2-2', 'es'), style: 'header', alignment: 'right' }]
              ]
            },
            pageBreak: (index < (this.listLineItemsBudget.length - 1) ? 'after' : ''),
          }
        );
      } else {
        loadedAllPdf = false;
        break;
      }
    }

    this.cachePartidasService.modifyOnBudget('procesTodosPdf', 'false');
    this.disableTodosPdf = false;
    this.apiCallService.hideSpinner();

    if (loadedAllPdf) {
      if (accion == 'open') {
        pdfMake.createPdf(docDefinition).open();
      } else {
        pdfMake.createPdf(docDefinition).download(reportpDFName);
      }
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_ERROR_LINEITEM_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
    }

  }

  closeDialogVerApusPresupuesto() {
    this.dialogVerApuPresupuestoRef.close();
  }

  ngOnDestroy(): void {
    this.closeDialogVerApusPresupuesto();
  }

}
